module.exports = __webpack_public_path__ + "img/block9-right.b47230be.jpg";